"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTreeAlterationSuitInverse = exports["default"] = void 0;
var _tree = require("./tree");
var _treeAlterationSuitPackage = _interopRequireDefault(require("./treeAlterationSuitPackage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // i18next-extract-mark-ns-start Trees
var getTreeAlterationSuit = function getTreeAlterationSuit(t) {
  var pricingVersion = (0, _tree.getPricingVersion)();
  return {
    question: {
      alteration: t('À quels endroits seront les retouches ?'),
      repair: t('À quels endroits seront les réparations ?'),
      embroidery: t('À quels endroits seront les broderies ?'),
      transformation: t('À quels endroits seront les transformations ?')
    },
    pieces: {
      mant: {
        name: t('Veste de costume'),
        label: t('La veste'),
        question: t('Indiquez-nous le problème sur la veste :'),
        problems: {
          tooLarge: {
            label: t('Elle est trop grande'),
            question: t('À quel endroit est-elle trop grande ?'),
            answers: [{
              slug: 'longArm',
              label: t('Manches trop longues'),
              id: "".concat(pricingVersion, ".mant-ret-rac-2")
            }, {
              slug: 'tooLong',
              label: t('Elle est trop longue'),
              id: "".concat(pricingVersion, ".mant-ret-rac-1")
            }, {
              slug: 'largeChest',
              label: t('Buste trop large'),
              id: "".concat(pricingVersion, ".mant-ret-cin-4")
            }, {
              slug: 'largeArm',
              label: t('Manches trop larges'),
              id: "".concat(pricingVersion, ".mant-ret-cin-2")
            }, {
              slug: 'largeShoulder',
              label: t('Épaules trop larges'),
              id: "".concat(pricingVersion, ".mant-ret-cin-1")
            }]
          },
          tooSmall: {
            label: t('Elle est trop petite'),
            question: t('À quel endroit est-elle trop petite ?'),
            answers: [{
              slug: 'shortArm',
              label: t('Manches trop courtes'),
              id: "".concat(pricingVersion, ".mant-ret-ral-2")
            }, {
              slug: 'shortChest',
              label: t('Buste trop étroit'),
              id: "".concat(pricingVersion, ".mant-ret-ela-4")
            }, {
              slug: 'tooShort',
              label: t('Elle est trop courte'),
              id: "".concat(pricingVersion, ".mant-ret-ral-1")
            }, {
              slug: 'armTooTight',
              label: t('Manches trop serrées'),
              id: "".concat(pricingVersion, ".mant-ret-ela-2")
            }, {
              slug: 'shoulderTooTight',
              label: t('Épaules trop serrées'),
              id: "".concat(pricingVersion, ".mant-ret-ela-1")
            }]
          },
          damaged: {
            label: t('Elle est abîmée'),
            question: t('À quel endroit est-elle abîmée ?'),
            answers: [{
              slug: 'entireLining',
              label: t('Sur toute la doublure'),
              id: "".concat(pricingVersion, ".mant-rep-div-3")
            }, {
              slug: 'liningPart',
              label: t('Sur une partie de la doublure'),
              id: "".concat(pricingVersion, ".mant-rep-div-2")
            }, {
              slug: 'pocket',
              label: t('Une poche est trouée'),
              id: "".concat(pricingVersion, ".mant-rep-tear-1"),
              isMultiple: true
            }, {
              slug: 'button',
              label: t('Il manque un bouton'),
              id: "".concat(pricingVersion, ".mant-rep-but-2"),
              isMultiple: true
            }, {
              slug: 'brokenZip',
              label: t('Le zip est bloqué'),
              id: "".concat(pricingVersion, ".mant-rep-zip-3"),
              isMultiple: true
            }, {
              slug: 'tornHoley',
              label: t('Elle est déchirée / trouée'),
              id: "".concat(pricingVersion, ".mant-rep-tear-1"),
              isMultiple: true
            }, {
              slug: 'reinforcement',
              label: t('Elle nécessite un renfort'),
              id: "".concat(pricingVersion, ".mant-rep-tear-2"),
              isMultiple: true
            }]
          },
          talkRDV: {
            label: t('En parler en RDV')
          }
        }
      },
      pant: {
        name: t('Pantalon de costume'),
        label: t('Le pantalon'),
        question: t('Indiquez-nous le problème sur le pantalon :'),
        problems: {
          tooLarge: {
            label: t('Il est trop grand'),
            question: t('À quel endroit est-il trop grand ?'),
            answers: [{
              slug: 'tooLargeLeg',
              label: t('Sur les jambes'),
              id: "".concat(pricingVersion, ".pant-ret-cin-2")
            }, {
              slug: 'tooLargeCrotch',
              label: t('A l’entrejambe'),
              id: "".concat(pricingVersion, ".pant-ret-cin-4")
            }, {
              slug: 'tooLargeBelt',
              label: t('A la ceinture'),
              id: "".concat(pricingVersion, ".pant-ret-cin-1")
            }, {
              slug: 'tooLargeLength',
              label: t('Sur la longueur'),
              id: "".concat(pricingVersion, ".pant-ret-rac-1"),
              isNotSuit: true
            }]
          },
          tooSmall: {
            label: t('Il est trop petit'),
            question: t('À quel endroit est-il trop petit ?'),
            answers: [{
              slug: 'tooSmallLeg',
              label: t('Sur les jambes'),
              id: "".concat(pricingVersion, ".pant-ret-ela-2")
            }, {
              slug: 'tooSmallCrotch',
              label: t('A l’entrejambe'),
              id: "".concat(pricingVersion, ".pant-ret-ela-4")
            }, {
              slug: 'tooSmallBelt',
              label: t('A la ceinture'),
              id: "".concat(pricingVersion, ".pant-ret-ela-1")
            }, {
              slug: 'tooSmallLength',
              label: t('Sur la longueur'),
              id: "".concat(pricingVersion, ".pant-ret-ral-2")
            }]
          },
          damaged: {
            label: t('Il est abîmé'),
            question: t('À quel endroit est-ce abîmé ?'),
            answers: [{
              slug: 'pocket',
              label: t('Une poche est trouée'),
              id: "".concat(pricingVersion, ".pant-rep-tear-1"),
              isMultiple: true,
              isNotSuit: true
            }, {
              slug: 'button',
              label: t('Il manque un bouton'),
              id: "".concat(pricingVersion, ".pant-rep-but-2"),
              isMultiple: true,
              isNotSuit: true
            }, {
              slug: 'brokenZip',
              label: t('Le zip est bloqué'),
              id: "".concat(pricingVersion, ".pant-rep-zip-1"),
              isMultiple: true,
              isNotSuit: true
            }, {
              slug: 'tornHoley',
              label: t('Il est déchiré / troué'),
              id: "".concat(pricingVersion, ".pant-rep-tear-1"),
              isMultiple: true,
              isNotSuit: true
            }, {
              slug: 'unraveledHem2',
              label: t('L‘ourlet est décousu (x2 jambes)'),
              id: "".concat(pricingVersion, ".pant-rep-div-7"),
              isNotSuit: true
            }]
          },
          hem: {
            label: t('Faire un ourlet'),
            question: t('À quel endroit est-il trop grand ?'),
            answers: [{
              slug: 'hem',
              label: t('Sur la longueur'),
              id: "".concat(pricingVersion, ".pant-ret-rac-1"),
              isNotSuit: true
            }]
          },
          talkRDV: {
            label: t('En parler en RDV')
          }
        }
      }
    }
  };
};
var getTreeAlterationSuitInverse = exports.getTreeAlterationSuitInverse = function getTreeAlterationSuitInverse(t, process) {
  var treeAlterationSuitInverse = {};
  var treeAlterationSuit = process === 'AT_HOME' ? getTreeAlterationSuit(t) : (0, _treeAlterationSuitPackage["default"])(t);
  Object.entries(treeAlterationSuit.pieces).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      pieceSlug = _ref2[0],
      piece = _ref2[1];
    Object.entries(piece.problems).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        problemSlug = _ref4[0],
        problem = _ref4[1];
      if (!problem.answers) return;
      problem.answers.forEach(function (answer) {
        treeAlterationSuitInverse["cost_".concat(pieceSlug, "_").concat(answer.slug)] = _objectSpread(_objectSpread({}, answer), {}, {
          piece: pieceSlug,
          problem: problemSlug
        });
      });
    });
  });
  return treeAlterationSuitInverse;
};
var _default = exports["default"] = getTreeAlterationSuit;